import React from 'react';
import { Descriptions, Modal, Typography } from 'antd';
import { displayQuotationRevisionLabel } from '@/utils/quotationRevisionPolicy';
import { formatMoney, UAE_MONEY_PROFILE } from '@/utils/format';
import type { Quotation } from '@/services/quotation.service';

const { Paragraph, Text } = Typography;

type Props = {
  open: boolean;
  quotation: Quotation;
  estimateLabel?: string | null;
  loading?: boolean;
  onCancel: () => void;
  onConfirm: () => void;
};

export const QuotationAcceptConfirmModal: React.FC<Props> = ({
  open,
  quotation,
  estimateLabel,
  loading,
  onCancel,
  onConfirm,
}) => {
  const currency = quotation.currency || 'AED';

  return (
    <Modal
      title="Mark Customer Accepted"
      open={open}
      onCancel={onCancel}
      onOk={onConfirm}
      confirmLoading={loading}
      okText="Confirm Acceptance"
    >
      <Paragraph>Confirm the customer has accepted this commercial offer.</Paragraph>
      <Descriptions bordered size="small" column={1}>
        <Descriptions.Item label="Quotation">{quotation.quotation_number}</Descriptions.Item>
        <Descriptions.Item label="Revision">
          {displayQuotationRevisionLabel(quotation.revision_number)}
        </Descriptions.Item>
        <Descriptions.Item label="Selling Price">
          {formatMoney(quotation.grand_total, { ...UAE_MONEY_PROFILE, currency })}
        </Descriptions.Item>
        <Descriptions.Item label="Estimate">{estimateLabel || '—'}</Descriptions.Item>
      </Descriptions>
      <Paragraph style={{ marginTop: 12 }}>
        <Text type="secondary">Only the current customer-submitted revision can be accepted.</Text>
      </Paragraph>
    </Modal>
  );
};

export default QuotationAcceptConfirmModal;
